import React from 'react';
import styles from './styles/Legal.module.css';
import { Navbar } from './Navbar';
import { Footer } from './Footer';


const PrivacyPolicy = () => (
  <>
  <Navbar />
  <div className={styles.container}>
    <h1 className={styles.h1}>Privacy Policy</h1>

    <p className={styles.p}><strong>Effective Date:</strong> 1st March 2025.</p>
    <p className={styles.p}>
      Vallidge Consulting Pte Ltd ("Xenorize," "we," "us," or "our") is committed to safeguarding your personal data and respecting your privacy rights.
      This Privacy Policy explains how we collect, use, disclose, store, and protect your information when you use our services,
      and outlines your rights in accordance with Singapore’s Personal Data Protection Act (PDPA) and other applicable data protection laws.
    </p>
    <p className={styles.p}>
      By accessing or using the Xenorize website, mobile apps, trading bots, educational modules, and community platforms (collectively, the "Platform"),
      you acknowledge that you have read and understood this Privacy Policy, and agree to our collection and use of your data as described herein.
    </p>

    <h2 className={styles.h2}>1. What Data We Collect</h2>
    <p className={styles.p}>We collect both personal and technical data necessary to provide, improve, and secure our services. Data categories include:</p>
    <ul className={styles.ul}>
      <li><strong>Identity & Contact Data:</strong> Full name, email address, and other identifiers.</li>
      <li><strong>Exchange Data:</strong> API keys (encrypted), account balances, trade history, etc.</li>
      <li><strong>Device & Technical Data:</strong> IP, browser, OS, device ID, etc.</li>
      <li><strong>Usage & Behavioral Data:</strong> Page views, scrolls, clicks, errors, etc.</li>
      <li><strong>Marketing Preferences:</strong> Opt-ins, click tracking, user tags.</li>
      <li><strong>Community Interaction Data:</strong> Content and metadata from Discord, Telegram, etc.</li>
    </ul>

    <h2 className={styles.h2}>2. How We Use Your Data</h2>
    <ul className={styles.ul}>
      <li>Provide platform features and services</li>
      <li>Personalize your experience</li>
      <li>Authenticate, secure, and monitor</li>
      <li>Improve system reliability</li>
      <li>Send updates and promotional content</li>
      <li>Comply with legal duties</li>
    </ul>

    <h2 className={styles.h2}>3. How We Share Your Data</h2>
    <p className={styles.p}>We do not sell your data. We share with trusted providers as needed:</p>
    <ul className={styles.ul}>
      <li><strong>Cloud Hosting:</strong> e.g., AWS</li>
      <li><strong>Analytics:</strong> e.g., Google Analytics</li>
      <li><strong>Communication:</strong> e.g., Brevo, Mailgun</li>
      <li><strong>Payments:</strong> e.g., Stripe</li>
      <li><strong>Authorities:</strong> When required</li>
    </ul>

    <h2 className={styles.h2}>4. Cookies and Tracking</h2>
    <ul className={styles.ul}>
      <li>Track sessions and preferences</li>
      <li>Measure engagement</li>
      <li>Optimize navigation</li>
      <li>Track marketing performance</li>
    </ul>

    <h2 className={styles.h2}>5. Your Rights</h2>
    <ul className={styles.ul}>
      <li><strong>Access / Correction / Deletion</strong></li>
      <li><strong>Withdraw Consent</strong></li>
      <li><strong>Cookie Management</strong></li>
    </ul>
    <p className={styles.p}>Contact us at <a href="mailto:hello@xenorize.com">hello@xenorize.com</a></p>

    <h2 className={styles.h2}>6. Data Retention</h2>
    <ul className={styles.ul}>
      <li>While account is active or legally required</li>
      <li>Until no longer necessary for purposes</li>
    </ul>

    <h2 className={styles.h2}>7. Data Security</h2>
    <ul className={styles.ul}>
      <li><strong>Encryption:</strong> In transit and at rest</li>
      <li><strong>Access Control:</strong> Role-based staff access</li>
      <li><strong>Audits:</strong> Regular security checks</li>
    </ul>

    <h2 className={styles.h2}>8. Cross-Border Transfers</h2>
    <p className={styles.p}>Data may be processed outside your country, including Singapore. Safeguards are applied where necessary.</p>

    <h2 className={styles.h2}>9. Children’s Privacy</h2>
    <p className={styles.p}>The platform is not for users under 18. We delete such data if detected.</p>

    <h2 className={styles.h2}>10. Policy Updates</h2>
    <p className={styles.p}>We may update this policy. We'll notify you of major changes.</p>

    <h2 className={styles.h2}>11. Contact Us</h2>
    <p className={styles.p}>
      <strong>Data Protection Officer</strong><br />
      Email: <a href="mailto:hello@xenorize.com">hello@xenorize.com</a>
    </p>
  </div>
  <Footer />
   </>
);

export default PrivacyPolicy;
